import axios from "axios"
import SendMail from "./SendMail"
import notifyError from "./notifyError"
import handleFailedHubSpotSubmission from "./handleFailedHubSpotSubmission"

const HubSpot = async (
  formGuid, // Set this to null to prevent hubspot submission. Form ID to submit to hubspot
  data = null, // Set this to null to prevent hubspot submission. Object to submit to hubspot
  formData = null,
  formTitle = null,
  emailSubject = null
) => {
  if (formData) {
    await SendMail(formData, formTitle, emailSubject)
  }

  let hubspotCookie = document.cookie.replace(
    /(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  )

  if (process.env.GATSBY_STAGE !== "production") {
    console.log("exit without submitting")
    return true
  }

  if (formGuid && data) {
    // submit the form

    let fields = []

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        fields.push({
          name: key,
          value: data[key],
        })
      }
    }
    const formattedData = {
      context: {
        hutk: hubspotCookie,
        pageUri: window.location.href || "https://workplaceone.com",
        pageName: document.title || "Workplace One",
      },
      fields: fields,
    }

    const headers = {
      "Content-Type": "application/json",
    }

    await axios
      .post(
        `https://api.hsforms.com/submissions/v3/integration/submit/6792877/${formGuid}`,
        JSON.stringify(formattedData),
        { headers }
      )
      .then(function (response) {
        return true
      })
      .catch(async (error) => {
        notifyError(
          `Couldn't submit HubSpot form ${formGuid} - ${error}\n\`${JSON.stringify(
            data
          )}\``
        )
        await handleFailedHubSpotSubmission(data, formData?.toEmail)
        console.log(error)
        return false
      })
  }
  return true
}

export default HubSpot
